import React from 'react';
import * as S from '../styles';

const overlayStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,0.7)',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    fontWeight: 500,
    color: '#4935c3',
};

const LoadingOverlay: React.FC = () => (
    <div style={overlayStyle}>
        <S.ProcessingIcon size={36} />
    </div>
);

export default LoadingOverlay;